import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { IoClose } from "react-icons/io5";
import globalContext from "../../Contexts/GlobalContext";
import { useNavigate } from "react-router-dom";
import BlueLoader from "../loader/BlueLoader";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import useRequestHeader from "../../hooks/useRequestHeader";
import MaskedInput from "react-text-mask";
import { FaWheelchair } from "react-icons/fa";
import { getValidPlateNumber } from "../../utils/plateLetterHandler";
export default function SelectViolationPlate({
  setIsSelectViolationPlateOpen,
  setIsNewViolationPlateOpen,
  setViolationPlate,
  setViolationCarLogo,
  setViolationCarModel,
}) {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [identifyCode, setIdentifyCode] = useState("");
  const [cookies, setCookies, removeCookies] = useCookies();
  const navigate = useNavigate();
  const [cars, setCars] = useState([]);

  useEffect(() => {
    try {
      var localStorageCars = JSON.parse(localStorage?.getItem("cars"));
      setCars(localStorageCars);
    } catch (e) {}
  }, []);

  return (
    <>
      <div
        className={`absolute h-[100vh]  w-[100vw] z-[1000] backdrop-blur-sm`}
        onClick={() => {
          setIsSelectViolationPlateOpen(false);
        }}
      ></div>

      <div
        className="bg-[#02161D] absolute w-full  font-font_primary_A h-auto px-[8vw] py-[6vw] rounded-t-[2.8vw] z-[10000] up "
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="w-full flex items-center justify-between font-font_primary_A  text-[#FFF]">
          <span className="text-[4vw]">تغییر پلاک</span>
          <span
            className="text-[6vw]"
            onClick={() => {
              setIsSelectViolationPlateOpen(false);
            }}
          >
            <IoClose />
          </span>
        </div>
        <div
          className="w-full h-[50px] flex items-center justify-center gap-x-[2vw] mt-[6vw] border-[1px] border-color-primary-D rounded-[1.8vw] text-[4vw] font-bold text-color-primary-D"
          onClick={() => {
            setIsSelectViolationPlateOpen(false);
            setIsNewViolationPlateOpen(true);
          }}
        >
          <span className="pt-[1vw]">+</span>
          <span className="">پلاک جدید</span>
        </div>

        <div className="w-full max-h-[55vw] overflow-auto mb-[4vw] gap-x-[2vw] mt-[6vw] ">
          {cars?.map((car) => (
            <div
              className="w-full relative   flex items-center gap-x-[6vw] border-[1px] border-color-primary-D bg-[#00f7ff28] rounded-[1.8vw] mt-[4vw] px-[4vw] py-[2vw]"
              onClick={(e) => {
                setViolationPlate(car?.plate);
                setViolationCarLogo(car?.srcLogo);
                setViolationCarModel(car?.model);
                setIsSelectViolationPlateOpen(false);
              }}
            >
              <div
                className=" w-[20vw] h-full flex items-center justify-center"
                onClick={() => {}}
              >
                <img
                  src={car?.srcLogo}
                  alt=""
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src =
                      "../assets/images/car-details/default logo.svg";
                  }}
                />
              </div>
              {/* //// plate section start //// */}

              <div className="relative w-full h-full flex flex-col items-center justify-center">
                <div className="w-full h-[40px] text-color-primary-A font-font_primary_A text-[3.5vw] flex items-center justify-start">
                  {car?.model || " مدل خودرو نامشخص"}
                </div>

                <div className="w-full h-[calc(100%-40px)]  flex flex-col items-start justify-end pb-[2vw]">
                  <div className="relative w-[54.00943396226415vw] h-[11.01179245283019vw] ">
                    <svg
                      width="54.00943396226415vw"
                      height="11.01179245283019vw"
                      viewBox="0 0 716 146"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.66016 0.00317383H707.889C710.142 0.00317383 711.945 0.90437 713.747 2.25616C715.099 3.60796 716 5.86095 716 7.66334V138.337C716 140.139 715.099 142.392 713.747 143.744C711.945 145.096 710.142 145.997 707.889 145.997H7.66016C5.85777 145.997 3.60478 145.096 2.25299 143.744C0.901196 142.392 0 140.139 0 138.337V7.66334C0 5.86095 0.901196 3.60796 2.25299 2.25616C3.60478 0.90437 5.85777 0.00317383 7.66016 0.00317383ZM63.9849 3.15736V142.843H546.125V3.15736H63.9849ZM60.8307 142.843V3.15736H7.66016C6.30837 3.15736 5.40717 3.60796 4.50598 4.50915C3.60478 5.41035 3.15419 6.31154 3.15419 7.66334V138.337C3.15419 139.238 3.60478 140.59 4.50598 141.491C5.40717 142.392 6.30837 142.843 7.66016 142.843H60.8307ZM549.279 3.15736V142.843H707.889C709.241 142.843 710.593 142.392 711.494 141.491C711.945 140.59 712.846 139.238 712.846 138.337V7.66334C712.846 6.31154 711.945 5.41035 711.494 4.50915C710.593 3.60796 709.241 3.15736 707.889 3.15736H549.279Z"
                        fill="#00FFF2"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.01196 104.992V87.8698H11.265V104.992H9.01196ZM20.2769 104.992V87.8698H27.0359C27.9371 87.8698 29.2889 87.8698 29.7395 88.3203C30.6407 88.3203 31.0913 89.2215 31.5419 89.6721C31.9925 90.5733 31.9925 91.4745 31.9925 92.3757C31.9925 93.7275 31.5419 94.6287 31.0913 95.5299C30.1901 96.4311 29.2889 96.8817 27.9371 96.8817C28.3877 97.3323 28.8383 97.7829 29.2889 97.7829C29.7395 98.6841 30.1901 99.1347 30.6407 100.036L33.3442 104.992H30.6407L28.8383 101.388C28.3877 100.486 27.9371 99.5853 27.4865 99.1347C27.0359 98.2335 26.5853 98.2335 26.5853 97.7829C26.1347 97.7829 25.6841 97.3323 25.6841 97.3323C25.2335 97.3323 24.7829 97.3323 24.3323 97.3323H22.0793V104.992H20.2769ZM22.0793 95.5299H26.5853C27.4865 95.5299 27.9371 95.0793 28.3877 95.0793C28.8383 94.6287 29.2889 94.6287 29.7395 94.1781C29.7395 93.7275 30.1901 92.8263 30.1901 92.3757C30.1901 91.4745 29.7395 91.0239 29.2889 90.5733C28.8383 90.1227 27.9371 89.6721 27.0359 89.6721H22.0793V95.5299ZM43.2574 131.578V114.455H45.0598L52.72 127.973V114.455H54.5223V131.578H52.72L45.0598 118.06V131.578H43.2574ZM27.9371 131.578L33.3442 114.455H35.5972L41.455 131.578H39.202L37.8502 126.621H31.5419L29.7395 131.578H27.9371ZM31.9925 124.368H36.949L35.5972 119.862C35.1466 118.51 34.696 117.159 34.2454 116.257C34.2454 117.159 33.7948 118.51 33.7948 119.412L31.9925 124.368ZM14.4191 131.578V114.455H21.1781C22.5299 114.455 23.4311 114.455 23.8817 114.906C24.7829 115.356 25.2335 115.807 25.6841 116.708C26.1347 117.159 26.1347 118.06 26.1347 118.961C26.1347 120.313 26.1347 121.214 25.2335 122.115C24.7829 123.016 23.4311 123.467 22.0793 123.918C22.5299 123.918 22.9805 124.368 23.4311 124.819C23.8817 125.269 24.3323 126.171 24.7829 127.072L27.4865 131.578H25.2335L22.9805 127.973C22.5299 127.072 22.0793 126.171 21.6287 125.72C21.1781 125.269 21.1781 124.819 20.7275 124.368C20.2769 124.368 20.2769 124.368 19.8263 123.918C19.8263 123.918 19.3757 123.918 18.9251 123.918H16.6721V131.578H14.4191ZM16.6721 122.115H20.7275C21.6287 122.115 22.0793 122.115 22.9805 121.665C23.4311 121.665 23.8817 121.214 23.8817 120.763C24.3323 120.313 24.3323 119.862 24.3323 118.961C24.3323 118.51 23.8817 117.609 23.4311 117.159C22.9805 116.708 22.0793 116.257 21.1781 116.257H16.6721V122.115ZM9.01196 131.578V114.455H11.265V131.578H9.01196ZM35.1466 104.992V102.289H37.3996V104.992H35.1466ZM14.8697 104.992V102.289H16.6721V104.992H14.8697Z"
                        fill="#00FFF2"
                      />
                      <path
                        d="M60.8307 142.843V3.15735H7.66015C6.30836 3.15735 5.40716 3.60795 4.50597 4.50914C3.60477 5.41034 3.15417 6.31153 3.15417 7.66333V138.337C3.15417 139.238 3.60477 140.59 4.50597 141.491C5.40716 142.392 6.30836 142.843 7.66015 142.843H60.8307Z"
                        fill="#00FFF2"
                        fillOpacity="0.2"
                      />
                    </svg>

                    <MaskedInput
                      mask={[/[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/]}
                      guide={false}
                      value={getValidPlateNumber(car?.plate, "3")}
                      type="tel"
                      dir="ltr"
                      disabled={true}
                      className={`absolute top-1/2 -translate-y-1/2 right-[2vw] w-[8.5vw] h-[5.971698113207547vw] bg-transparent    text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText flex items-center justify-center text-center text-[5.5vw] focus:text-[5.5vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw] `}
                    />

                    <MaskedInput
                      mask={[
                        /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                        /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                        /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                      ]}
                      guide={false}
                      value={getValidPlateNumber(car?.plate, "2")}
                      type="tel"
                      dir="ltr"
                      disabled={true}
                      className={`absolute top-1/2 -translate-y-1/2  right-[14vw] w-[14.3vw] h-[5.971698113207547vw] bg-transparent ml-[2vw] text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText flex items-center justify-center text-center text-[5.5vw] focus:text-[5.5vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw]`}
                    />
                    <div
                      className={`absolute top-1/2 -translate-y-1/2 right-[30vw] w-[6.344339622641509vw] h-[5.971698113207547vw]   z-50 ml-[2vw]  bg-transparent flex items-center justify-center text-center text-color-primary-ImportBoxText  text-[5vw] font-font_primary_A outline-none leading-[5.9vw]`}
                    >
                      <span>
                        {getValidPlateNumber(car?.plate, "S") === "&" ? (
                          <FaWheelchair size={16.5} />
                        ) : (
                          getValidPlateNumber(car?.plate, "S")
                        )}
                      </span>
                    </div>

                    <MaskedInput
                      mask={[/[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/]}
                      guide={false}
                      value={getValidPlateNumber(car?.plate, "1")}
                      type="tel"
                      dir="ltr"
                      disabled={true}
                      className={`absolute top-1/2 -translate-y-1/2 right-[39vw] w-[8.5vw] h-[5.971698113207547vw] bg-transparent  text-color-primary-ImportBoxText  focus:text-color-primary-ImportBoxText flex items-center justify-center text-center focus:text-center text-[5.5vw] focus:text-[5.5vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none z-50 leading-[5.9vw] `}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
